import { useEffect, useState } from "react";
import axios from "axios";
// react-router-dom components
import { Link } from "react-router-dom";
import routes from "routes";
import { adminKey } from "services/config";
// @mui material components
import Switch from "@mui/material/Switch";

// Kaizen Dashboard components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import CircularProgress from "@mui/material/CircularProgress";

import { urlBase } from "../../../services/config";
import { rolesConAcceso } from "services/config";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import curved9 from "assets/images/curved-images/FB_post.jpg";
//Constante con nombres pc habilitadas
const NOMBRES_PC_HABILITADAS = {
  nombres: [
    "kaizen",
    "PAPELERA_1",
    "PAPELERA_2",
    "PAPELERA_3",
    "PAPELERA_4",
    "PAPELERA_5",
    "MATEO",
    "KAIZEN-PC2",
    "DESKTOP-GOOM0E3",
  ],
};
//Constante vacía para set pc no habilitada
const ITEM_VACIO = {
  nombre: "",
};

function SignIn() {
  const sha512 = require("js-sha512");

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [emptyFields, setEmptyFields] = useState(false);
  const [rememberMe, setRememberMe] = useState(true);
  const [errorLogin, setErrorLogin] = useState(null);
  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   if (error) {
  //     if (error.message === "Failed to fetch") setErrorLogin("No se pudo conectar con el servidor");
  //     else setErrorLogin(error.networkError.result.errors[0].message);
  //   }
  // }, [error]);

  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const handleChanges = (event) => {
    const { name, value } = event.target;
    if (name === "username") setUsername(value);
    if (name === "password") setPassword(value);
  };

  const handleLogin = (event) => {
    setLoading(true);
    event.preventDefault();
    setErrorLogin(null);
    if (username !== "" && password !== "") {
      setEmptyFields(false);
      const variables = {
        user: username,
        password: password,
      };

      axios
        .post(urlBase + "login", variables)
        .then((res) => {
          const user = {
            user: username,
            password: password,
            token: res.data.token,
          };

          if (res.data.token !== null) {
            axios
              .get(urlBase + "user-profile", {
                headers: { Authorization: `Bearer ${user.token}` },
              })
              .then((res) => {
                const user_profile = {
                  ...res.data.userData,
                  idEmpleado: res.data.idEmpleado ? res.data.idEmpleado : "",
                  id_rol: "5",
                  nombre: res.data.nombre,
                  codigo: res.data.codigo,
                };

                if (user_profile) {
                  if (rememberMe) {
                    localStorage.setItem("user", JSON.stringify(user_profile));
                  } else {
                    sessionStorage.setItem("user", JSON.stringify(user_profile));
                  }

                  const userRoutes = routes.filter((route) =>
                    route.access?.includes(user_profile.id_rol)
                  );
                  if (user_profile.id_rol == 0) {
                    window.location.href = "/remitos";
                  } else if (user_profile.id_rol && rolesConAcceso.includes(user_profile.id_rol)) {
                    window.location.href = "/remitos";
                  } else {
                    window.location.href = "/remitos";
                  }
                }
              });
          }
        })
        .catch((error) => {
          if (error.response?.status == 401) {
            setErrorLogin("Usuario o contraseña incorrectos");
          } else {
            setErrorLogin("Error al iniciar sesión");
          }
          setLoading(false);
        });

      // if (rememberMe) {
      //   localStorage.setItem("user", JSON.stringify(user));
      // } else {
      //   sessionStorage.setItem("user", JSON.stringify(user));
      // }

      // if (result.data.login !== null) {
      //   const user = result.data.login;
      //   const deviceDetector = new DeviceDetector();
      //   const device = deviceDetector.parse(navigator.userAgent);
      //   if (rememberMe) {
      //     localStorage.setItem("user", JSON.stringify(user));
      //   } else {
      //     sessionStorage.setItem("user", JSON.stringify(user));
      //   }

      //   if (user.user.empleado) {
      //     if (user.user.empleado.puesto && rolesConAcceso.includes(user.user.empleado.puesto.id)) {
      //       if (device.device.type === "desktop") {
      //         window.location.href = "/remitos";
      //       } else {
      //         window.location.href = "/empleado/perfil";
      //       }
      //     } else {
      //       window.location.href = "/empleado/perfil";
      //     }
      //   }else{
      //     window.location.href = "/remitos";
      //   }
      // }
    } else {
      setEmptyFields(true);
      setLoading(false);
    }

    // event.preventDefault();
    // setErrorLogin(null);
    // if (username !== "" && password !== "") {
    //   setEmptyFields(false);
    //   loginUser({
    //     variables: {
    //       userInput: {
    //         username: username,
    //         password: sha512(password),
    //       },
    //     },
    //   })
    //     .then((result) => {
    //       if (result.data.login !== null) {
    //         const user = result.data.login;
    //         const deviceDetector = new DeviceDetector();
    //         const device = deviceDetector.parse(navigator.userAgent);
    //         if (rememberMe) {
    //           localStorage.setItem("user", JSON.stringify(user));
    //         } else {
    //           sessionStorage.setItem("user", JSON.stringify(user));
    //         }

    //         if (user.user.empleado) {
    //           if (user.user.empleado.puesto && rolesConAcceso.includes(user.user.empleado.puesto.id)) {
    //             if (device.device.type === "desktop") {
    //               window.location.href = "/remitos";
    //             } else {
    //               window.location.href = "/empleado/perfil";
    //             }
    //           } else {
    //             window.location.href = "/empleado/perfil";
    //           }
    //         }else{
    //           window.location.href = "/remitos";
    //         }
    //       }
    //     })
    //     .catch((error) => {
    //       setErrorLogin(error.message);
    //     });
    // } else {
    //   setEmptyFields(true);
    // }
  };
  useEffect(() => {
    if (username.length > 0 && password.length > 0) {
      setEmptyFields(false);
    }
    setErrorLogin(null);
  }, [username, password]);

  return (
    <CoverLayout
      title="Bienvenido"
      description="Ingrese su usuario y contraseña para iniciar sesión"
      image={curved9}
    >
      <SoftBox component="form" role="form" autoComplete="off">
        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="subtitle2" fontWeight="bold">
              Usuario
            </SoftTypography>
          </SoftBox>
          <SoftInput
            type="text"
            placeholder="Usuario"
            name="username"
            value={username}
            onChange={handleChanges}
            // error={data && data.authenticateUser === null}
            autoComplete="new-password"
          />
        </SoftBox>
        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="subtitle2" fontWeight="bold">
              Contraseña
            </SoftTypography>
          </SoftBox>
          <SoftInput
            type="password"
            placeholder="Contraseña"
            name="password"
            value={password}
            onChange={handleChanges}
            // error={data && data.authenticateUser === null}
            autoComplete="new-password"
          />
        </SoftBox>
        <SoftBox display="flex" alignItems="center">
          <Switch checked={rememberMe} onChange={handleSetRememberMe} />
          <SoftTypography
            variant="button"
            fontWeight="regular"
            onClick={handleSetRememberMe}
            sx={{ cursor: "pointer", userSelect: "none" }}
          >
            &nbsp;&nbsp;Mantenerme conectado
          </SoftTypography>
        </SoftBox>
        <SoftBox mt={4} mb={1}>
          <SoftButton
            type="submit"
            variant="gradient"
            color="primary"
            fullWidth
            onClick={(e) => {
              handleLogin(e);
            }}
            disabled={loading}
          >
            {loading ? <CircularProgress color="inherit" size={20} /> : "Iniciar sesión"}
            {/* Iniciar sesión */}
          </SoftButton>
        </SoftBox>
        <SoftBox mt={3} display="flex" justifyContent="center" alignItems="center">
          {emptyFields && (
            <SoftTypography variant="h6" color="error" fontWeight="bold">
              Debes ingresar un usuario y contraseña
            </SoftTypography>
          )}
          {!emptyFields && errorLogin && (
            <SoftTypography variant="h6" color="error" fontWeight="bold">
              {errorLogin}
            </SoftTypography>
          )}
        </SoftBox>
        {/* <SoftBox mt={3} textAlign="center">
          <SoftTypography variant="button" color="text" fontWeight="regular">
            Olvidaste tu contraseña?{" "}
            <SoftTypography
              component={Link}
              to="/authentication/sign-up"
              variant="button"
              color="dark"
              fontWeight="medium"
              textGradient
            >
              Hace click aquí
            </SoftTypography>
          </SoftTypography>
        </SoftBox> */}
      </SoftBox>
    </CoverLayout>
  );
}

export default SignIn;
